import Step from './DashboardBuilderStep'
import settingsConfig from 'DashboardBuilder/settingsConfig'
import SettingsForm from './Settings/SettingsForm'
import { useAct } from 'DashboardBuilder/store'

function SettingsShortDescriptor({ complete }) {
  return (
    <div>
      <div>
        { complete && <p className='complete no-margin-bottom'>You have completed the settings for this dashboard</p> }
        { !complete && <p className='incomplete no-margin-bottom'>Complete the settings for your dashboard</p> }
      </div>
    </div>
  )
}

function validate(settings) {
  const validationErrors = []

  const customConfig = _.omitBy(settingsConfig, (setting, key) => setting.dependsOn && !_.every(setting.dependsOn, (value, key) => _.includes(settings[key], value)))

  _.each(customConfig, (setting, key) => {
    if (setting.required) {
      if (setting.keys) {
        const keys = setting.keys
        keys.forEach((key) => {
          if (!settings[key] || settings[key] === 'not-selected') {
            validationErrors.push(`You must set ${setting.label}`)
          }
        })
      } else if (!settings[key] || settings[key] === 'not-selected') {
        validationErrors.push(`You must set ${setting.label}`)
      }
    }
  })

  return validationErrors
}

const Settings = () => {
  const act = useAct()
  const { settings } = useSel((s) => s.dashboard)

  const validationErrors = validate(settings)
  const complete = validationErrors.length === 0

  function save() {
    return act.builder.save('settings').then(() => {
      act.builder.closeEditor()
    })
  }

  return <Step
    name='Settings'
    editor='settings'
    complete={complete}
    shortDescriptor={ <SettingsShortDescriptor complete={complete} /> }
    canClickFinish={validationErrors.length === 0}
    validationErrors={validationErrors}
    save={save}
  >
    <SettingsForm />
  </Step>
}

export default Settings
